import { USER_SETTINGS_KEYS } from 'src/constants/userSetting';

/**
 * The company on screen, or '' when there is none. localStorage genuinely holds the strings 'null' and 'undefined' when no
 * company is selected, and a bare falsy check lets both through — which builds a request to /companies/null/bills.
 */
export const getCurrentCompanyId = () => {
  const stored = localStorage.getItem(USER_SETTINGS_KEYS.company);
  return !stored || stored === 'null' || stored === 'undefined' ? '' : stored;
};